module.exports = __webpack_public_path__ + "img/1-2.2a384d22.jpg";